import { ColumnDef } from '@tanstack/react-table';
import { DocumentTableProps } from '@/lib/types/constants';

export const columns: ColumnDef<DocumentTableProps>[] = [
	{
		accessorKey: 'name',
		header: ({ column }) => {
			return (
				<h5
					key={column.id}
					className="p-0 text-black bg-transparent text-heading6 xl:text-heading5"
				>
					Name
				</h5>
			);
		},
		cell: ({ row }) => {
			return (
				<a
					className="dynamic-text text-primary line-clamp-2"
					// onClick={() => handleDocument(row.original.documentId)}
				>
					{row.original.name}
				</a>
			);
		},
	},
	// {
	// 	accessorKey: 'category',
	// 	header: ({ column }) => (
	// 		<h5
	// 			key={column.id}
	// 			className="p-0 text-black bg-transparent text-heading6 xl:text-heading5"
	// 		>
	// 			Category
	// 		</h5>
	// 	),
	// 	cell: ({ row }) => {
	// 		return (
	// 			<p className="text-sm text-black xl:text-base">
	// 				{row.original.category}
	// 			</p>
	// 		);
	// 	},
	// },
];
